var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgWallet = function SvgWallet(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10.0002V11.3335C14 12.0699 13.403 12.6668 12.6667 12.6668H2.66667C1.93029 12.6668 1.33333 12.0699 1.33333 11.3335V4.66683C1.33333 3.93045 1.93029 3.3335 2.66667 3.3335H12.6667C13.403 3.3335 14 3.93045 14 4.66683V6.00016C14.3682 6.00016 14.6667 6.29864 14.6667 6.66683V9.3335C14.6667 9.70169 14.3682 10.0002 14 10.0002ZM12.6667 6.00016V4.66683H2.66667V11.3335H12.6667V10.0002H10.6667C10.2985 10.0002 10 9.70169 10 9.3335V6.66683C10 6.29864 10.2985 6.00016 10.6667 6.00016H12.6667ZM11.3333 8.66683V7.3335H13.3333V8.66683H11.3333Z",
    fill: "currentColor"
  })));
};
export default SvgWallet;